import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const HistoryPayments = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [payments, setPayments] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [aziendaData, setAziendaData] = useState(null);

  useEffect(() => {
    const fetchHistory = async () => {
      setLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      
      if (user) {
        const { data: profil } = await supabase
          .from('profili')
          .select('id_azienda, ruolo')
          .eq('id', user.id)
          .single();

        setUserRole(profil?.ruolo);

        if (profil?.id_azienda && (profil.ruolo === 'superAdmin' || profil.ruolo === 'Admin' || profil.ruolo === 'Owner' )) {
          const { data: azienda } = await supabase
            .from('aziende')
            .select('*')
            .eq('id', profil.id_azienda)
            .single();
          
          setAziendaData(azienda);

          const { data: history, error } = await supabase
            .from('pagamenti_storia')
            .select('*')
            .eq('id_azienda', profil.id_azienda)
            .order('creato_il', { ascending: false });

          if (!error) {
            setPayments(history);
          }
        }
      }
      setLoading(false);
    };

    fetchHistory();
  }, []);

  // PDF FUNKCIJA (LOGIKA OSTAJE ISTA KAKO SI TRAŽIO)
 const generatePDF = (payment) => {
    try {
      const doc = new jsPDF();
      const primaryColor = [15, 23, 42];
      const accentColor = [59, 130, 246];
      const textColor = [51, 65, 85];
      
      doc.setFillColor(...primaryColor);
      doc.rect(0, 0, 210, 45, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(24);
      doc.text("OrizonDesk", 15, 22);
      
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(148, 163, 184);
      doc.text("DIGITAL SAAS SOLUTIONS", 15, 28);
      doc.text("PAYMENT RECEIPT", 15, 33);

      const logoX = 180;
      doc.setDrawColor(59, 130, 246);
      doc.setFillColor(59, 130, 246);
      
      doc.lines([[5, 2], [10, 0], [5, -2], [0, 10], [-10, 5], [0, -10]], logoX, 12, [1, 1], 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("O", logoX + 5, 21.5, { align: "center" });

      doc.setFillColor(...accentColor);
      doc.rect(15, 55, 10, 2, 'F');

      doc.setTextColor(...primaryColor);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("RECIPIENT", 15, 65);
      
      doc.setTextColor(...textColor);
      doc.setFont("helvetica", "normal");
      doc.text(`${aziendaData?.nome_azienda || 'N/A'}`, 15, 71);
      doc.setFontSize(9);
      doc.text(`Email: ${payment.email_pagamento}`, 15, 76);
      doc.text(`ID: ${payment.id_azienda}`, 15, 81);

      doc.setFont("courier", "bold");
      doc.setTextColor(...primaryColor);
      doc.text("TRANSACTION INFO", 130, 65);
      
      doc.setFont("courier", "normal");
      doc.setFontSize(9);
      doc.text(`DATE: ${new Date(payment.creato_il).toLocaleDateString('en-GB')}`, 130, 71);
      doc.text(`TRX : ${payment.id_transazione_paypal.slice(0, 16)}`, 130, 76);
      
      doc.setFillColor(241, 245, 249);
      doc.rect(130, 80, 40, 6, 'F');
      doc.setTextColor(...accentColor);
      doc.setFont("helvetica", "bold");
      doc.text(payment.stato_pagamento.toUpperCase(), 133, 84.5);

      autoTable(doc, {
        startY: 95,
        head: [['ITEM DESCRIPTION', 'SERVICE PERIOD', 'PRICE']],
        body: [
          [
            { content: `OrizonDesk ${payment.nome_pacchetto} Subscription`, styles: { fontStyle: 'bold' } },
            `${new Date(payment.data_inizio).toLocaleDateString('en-GB')} - ${new Date(payment.data_fine).toLocaleDateString('en-GB')}`,
            { content: `${payment.importo} ${payment.valuta}`, styles: { halign: 'right', fontStyle: 'bold' } }
          ]
        ],
        headStyles: { fillColor: [30, 41, 59], textColor: [255, 255, 255], fontSize: 9, padding: 5 },
        styles: { font: "helvetica", fontSize: 9, cellPadding: 6, lineColor: [241, 245, 249], lineWidth: 0.1 },
        theme: 'striped'
      });

      const finalY = doc.lastAutoTable.finalY + 15;
      doc.setTextColor(...primaryColor);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text(`Total Amount: ${payment.importo} ${payment.valuta}`, 195, finalY, { align: 'right' });

      doc.setDrawColor(241, 245, 249);
      doc.line(15, 270, 195, 270);
      doc.setFontSize(8);
      doc.setTextColor(148, 163, 184);
      doc.setFont("helvetica", "normal");
      doc.text("ORIZONDESK PORTAL  •  WWW.ORIZON-DESK.COM", 105, 278, null, null, "center");
      doc.save(`Receipt_${payment.id_transazione_paypal.slice(-8)}.pdf`);
    } catch (error) {
      console.error("PDF Error:", error);
    }
  };

  if (loading) return <div className="h-64 w-full bg-muted/20 animate-pulse rounded-[2.5rem] mt-16" />;
  
  if (userRole !== 'superAdmin' && userRole !== 'Admin' && userRole !== 'Owner') {
    return (
      <div className="p-10 text-center bg-destructive/5 border border-destructive/20 rounded-[2.5rem] mt-10">
        <Icon name="ShieldAlert" size={40} className="mx-auto text-destructive mb-4" />
        <p className="text-sm font-black uppercase tracking-widest text-destructive">
          {t('payments.no_permission')}
        </p>
      </div>
    );
  }

  return (
    <div className="w-full mt-4 animate-in fade-in slide-in-from-top-4 duration-700">
      
      {/* BACK BUTTON */}
      <div className="flex justify-start mb-6">
        <button 
          onClick={() => navigate(-1)} 
          className="group flex items-center gap-2 text-muted-foreground hover:text-primary transition-all duration-300"
        >
          <div className="p-2 rounded-xl bg-muted/30 group-hover:bg-primary/10 transition-colors">
            <Icon name="ArrowLeft" size={20} className="group-hover:-translate-x-1 transition-transform" />
          </div>
          <span className="text-[11px] font-black uppercase tracking-[0.2em]">
            {t('payments.back')}
          </span>
        </button>
      </div>

      {/* NASLOV */}
      <div className="relative mb-10">
        <div className="flex flex-col relative z-10 bg-background pr-4 w-fit">
          <h2 className="text-2xl font-black uppercase tracking-tighter flex items-center gap-3 text-foreground/90">
            <div className="p-2 bg-emerald-500 rounded-lg text-white shadow-lg shadow-emerald-500/20">
              <Icon name="Receipt" size={20} />
            </div>
            {t('payments.title')}
          </h2>
          <p className="text-xs text-muted-foreground font-semibold mt-1 opacity-80 tracking-wide italic ml-12">
            {t('payments.subtitle')}
          </p>
        </div>
        <div className="absolute bottom-[-20px] left-0 w-full h-[1px] bg-gradient-to-r from-border via-border to-transparent" />
      </div>

      {/* TABELA */}
      <div className="bg-card rounded-[2.5rem] border border-border/60 shadow-sm overflow-hidden transition-all duration-300 hover:shadow-xl">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-muted/30 border-b border-border/50">
                <th className="px-6 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground">{t('payments.table.period')}</th>
                <th className="px-6 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground">{t('payments.table.admin_email')}</th>
                <th className="px-6 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground">{t('payments.table.package_id')}</th>
                <th className="px-6 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground">{t('payments.table.amount')}</th>
                <th className="px-6 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground text-center">{t('payments.table.status_pdf')}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border/40">
              {payments.length > 0 ? (
                payments.map((payment) => (
                  <tr key={payment.id} className="hover:bg-primary/[0.02] transition-colors group">
                    <td className="px-6 py-5">
                      <div className="flex items-center gap-4">
                        <div className="flex flex-col">
                          <span className="text-[10px] font-black text-muted-foreground uppercase tracking-tighter">{t('payments.table.from')}</span>
                          <span className="text-sm font-bold text-foreground">
                            {new Date(payment.data_inizio).toLocaleDateString('de-DE')}
                          </span>
                        </div>
                        <Icon name="ArrowRight" size={14} className="text-muted-foreground/30 mt-3" />
                        <div className="flex flex-col">
                          <span className="text-[10px] font-black text-emerald-500 uppercase tracking-tighter">{t('payments.table.to')}</span>
                          <span className="text-sm font-bold text-foreground">
                            {new Date(payment.data_fine).toLocaleDateString('de-DE')}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-5">
                      <div className="flex flex-col">
                        <div className="flex items-center gap-1.5 mb-0.5">
                          <Icon name="User" size={12} className="text-primary" />
                          <span className="text-xs font-black uppercase tracking-tight text-foreground/80">{t('payments.table.paid_by')}</span>
                        </div>
                        <span className="text-[11px] font-medium text-muted-foreground lowercase">
                          {payment.email_pagamento}
                        </span>
                      </div>
                    </td>

                    <td className="px-6 py-5">
                      <div className="flex flex-col gap-1.5">
                        <div className="flex items-center gap-2">
                           <span className="text-[12px] font-black uppercase bg-primary/10 text-primary px-2 py-0.5 rounded">
                             {payment.nome_pacchetto}
                           </span>
                        </div>
                        <span className="text-[11px] font-mono font-bold text-muted-foreground/60 tracking-tighter uppercase">
                          ID: {payment.id_transazione_paypal}
                        </span>
                      </div>
                    </td>

                    <td className="px-6 py-5">
                      <div className="flex flex-col">
                        <span className="text-sm font-black text-foreground">
                          {payment.importo} {payment.valuta}
                        </span>
                        <div className="flex items-center gap-1 mt-0.5 opacity-50">
                          <Icon name="CreditCard" size={10} />
                          <span className="text-[9px] font-bold uppercase tracking-widest">{t('payments.table.online')}</span>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-5">
                      <div className="flex flex-col items-center gap-2">
                        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-600 text-[9px] font-black uppercase tracking-tighter">
                          {payment.stato_pagamento}
                        </span>
                        <button 
                          onClick={() => generatePDF(payment)}
                          className="flex items-center gap-1.5 text-[11px] font-black uppercase tracking-widest text-primary bg-primary/5 px-3 py-1.5 rounded-lg border border-primary/10 cursor-pointer transition-all duration-200 ease-out hover:bg-primary hover:text-white hover:scale-105 hover:shadow-lg hover:shadow-primary/20 active:scale-95"
                        >
                          <Icon name="FileText" size={12} />
                          PDF
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-6 py-20 text-center text-muted-foreground opacity-30">
                    <Icon name="Inbox" size={40} className="mx-auto mb-2" />
                    <p className="text-[10px] font-black uppercase tracking-widest">{t('payments.table.no_transactions')}</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        
        {/* FOOTER */}
        <div className="bg-muted/10 px-8 py-5 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
             <div className="p-2 bg-background rounded-lg border border-border">
                <Icon name="Info" size={14} className="text-primary" />
             </div>
             <p className="text-[9px] font-black uppercase tracking-[0.10em] text-muted-foreground max-w-md">
               {t('payments.footer.note')}
             </p>
          </div>
          <div className="flex items-center gap-4 border-l pl-6 border-border/50">
             <div className="text-right">
                <p className="text-[8px] font-black uppercase text-muted-foreground/50 tracking-widest">{t('payments.footer.system_status')}</p>
                <p className="text-[10px] font-black text-emerald-500 uppercase">{t('payments.footer.verified')}</p>
             </div>
             <Icon name="ShieldCheck" size={24} className="text-emerald-500/50" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryPayments;